import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from '../useSelector';
import { EXPERIMENT_GROUP, CONTROL_GROUP, experimentGroupCheckFunction } from './experimentCheckFunction';
export function useExperimentGroupCheckFunction(sendCheck = true) {
  const exps = useSelector(({
    experiments
  }) => experiments);
  const dispatch = useDispatch();
  return useCallback(experimentName => {
    return experimentGroupCheckFunction(exps, experimentName, dispatch, sendCheck);
  }, [dispatch, exps, sendCheck]);
}
export default function useExperimentCheckFunction(callHook = true, sendCheck = true) {
  const getExperimentGroup = useExperimentGroupCheckFunction(sendCheck);
  return useCallback(experimentName => {
    if (!callHook) {
      return false;
    }
    return getExperimentGroup(experimentName) === EXPERIMENT_GROUP;
  }, [getExperimentGroup, callHook]);
}
export function useExperimentControlCheckFunction(callHook = true, sendCheck = true) {
  const getExperimentGroup = useExperimentGroupCheckFunction(sendCheck);
  return useCallback((experimentNames = []) => {
    if (!callHook) {
      return false;
    }
    return experimentNames.some(experimentName => {
      return getExperimentGroup(experimentName) === CONTROL_GROUP;
    });
  }, [callHook, getExperimentGroup]);
}
//# sourceMappingURL=useExperimentCheckFunction.js.map